import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

import fr from './locales/fr.json'
import en from './locales/en.json'
import wo from './locales/wo.json'
import ln from './locales/ln.json'
import sw from './locales/sw.json'
import ff from './locales/ff.json'

const resources = {
  fr: { translation: fr },
  en: { translation: en },
  wo: { translation: wo },
  ln: { translation: ln },
  sw: { translation: sw },
  ff: { translation: ff },
}

export const supportedLanguages = [
  { code: 'fr', name: 'Français', nativeName: 'Français' },
  { code: 'en', name: 'English', nativeName: 'English' },
  { code: 'wo', name: 'Wolof', nativeName: 'Wolof' },
  { code: 'ln', name: 'Lingala', nativeName: 'Lingála' },
  { code: 'sw', name: 'Swahili', nativeName: 'Kiswahili' },
  { code: 'ff', name: 'Fulfulde', nativeName: 'Fulfulde' },
] as const

export type SupportedLanguage = typeof supportedLanguages[number]['code']

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'fr',
    fallbackLng: 'fr',
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    },
  })

export default i18n
